import { redirectLegacyPortalHost } from '@djgg/cloud';

declare global {
  var __DJGG_CANONICAL_REDIRECT__: boolean | undefined;
}

// Kept as a tiny first module in index.html so a legacy shared URL moves to
// the branded origin before the portal initializes Firebase or renders.
globalThis.__DJGG_CANONICAL_REDIRECT__ = redirectLegacyPortalHost();
